module.exports = __webpack_public_path__ + "img/preloader-bg-image.5d11fc10.png";